import Vue from 'vue'
import Vuex from 'vuex'
import ApiClient from './common/api.js';
import VueCookies from 'vue-cookies';


Vue.use(Vuex)
Vue.use(VueCookies)

export default new Vuex.Store({
    state: {
        token: null,
        errors: [],
        user: null,
        tantoList: null,
        eigyoList: null,
        postParam: {},
        initDetail: false,
        searchList: null,
        displayItems: {},
        mailList: null,
        customerList: null,
        customerName: null,
        partnerDisplayItems: {},
        customsBrokerDisplayItems: {},
    },
    getters: {
        token(state) {
            if (!state.token) {
                if (!VueCookies.get('__jwt_token_admin')) {
                    return '';
                }
                state.token = VueCookies.get('__jwt_token_admin');
            }
            return state.token;
        },
        errors(state) {
            return state.errors;
        },

        getPostParam: (state) => state.postParam,

        getDisplayItems(state) {
          if (Object.keys(state.displayItems).length == 0) {
            if (VueCookies.get('displayItems') == null) {
              return {};
            }
            state.displayItems = VueCookies.get('displayItems');
          }
          return state.displayItems;
        },

        defaultSetDisplayItems(state) {
          const defaultDisplayItems = {
            status: true,
            customs_broker: true,
            rv: true,
            comment_flg: true,
            input_date: true,
            shipper_name: true,
            booking: true,
            ship_name: true,
            voy: true,
            place_of_receipt: true,
            loading_area: true,
            landing_area: true,
            departure_date:true,
            cut_date: true,
            quantity: true,
            sts_ship: true,
            container_info: true,
            pick_up_flg: true,
            pick_up_date: true,
            pick_up_time: true,
            working_style: true,
            shipping_form: true,
            customs_clearance: true,
            cargo_location: true,
            ledger_number: true,
            custom_materials_flg: true,
            ms_i_flg: true,
            hs_i_flg: true,
            vehicle_information_flg: true,
            picture_flg: true,
            carry_in_slip_flg: true,
            acl_flg: true,
            export_permit_flg: true,
            draft_bl_flg: true,
            freight_detail_flg: true,
            debit_note_flg: true,
            mbl_flg: true,
            hbl_flg: true,
            invoice_flg: true,
          };

          const savedDisplayItems = VueCookies.get('displayItems');
          let displayItems;

          if (!savedDisplayItems || Object.keys(savedDisplayItems).length !== Object.keys(defaultDisplayItems).length) {
            displayItems = { ...defaultDisplayItems };

            if (savedDisplayItems) {
              for (const key in defaultDisplayItems) {
                if (savedDisplayItems[key] != null) {
                  displayItems[key] = savedDisplayItems[key];
                }
              }
            }

            VueCookies.set('displayItems', JSON.stringify(displayItems));
          } else {
            displayItems = savedDisplayItems;
          }

          state.displayItems = displayItems;
          return VueCookies.get('displayItems')
        },

        getPartnerDisplayItems(state) {
          if (Object.keys(state.partnerDisplayItems).length == 0) {
            if (VueCookies.get('partnerDisplayItems') == null) {
              return {};
            }
            state.partnerDisplayItems = VueCookies.get('partnerDisplayItems');
          }
          return state.partnerDisplayItems;
        },
        defaultSetPartnerDisplayItems(state) {
          const defaultPartnerDisplayItems = {
            status: true,
            rv: true,
            agent_comment_flg: true,
            shipper_name: true,
            consignee: true,
            place_of_receipt: true,
            cargo_location: false,
            booking: true,
            quantity: true,
            sts_ship: true,
            container_info: true,
            custom_materials_flg: true,
            ms_i_flg: true,
            hs_i_flg: true,
            vehicle_information_flg: true,
            picture_flg: true,
            carry_in_slip_flg: true,
            export_permit_flg: true,
            draft_bl_flg: true,
            hbl_flg: true,
            mbl_flg: true,
            debit_note_flg: true,
          };

          const savedPartnerDisplayItems = VueCookies.get('partnerDisplayItems');
          let partnerDisplayItems;

          if (!savedPartnerDisplayItems || Object.keys(savedPartnerDisplayItems).length !== Object.keys(defaultPartnerDisplayItems).length) {
            partnerDisplayItems = { ...defaultPartnerDisplayItems };

            if (savedPartnerDisplayItems) {
              for (const key in defaultPartnerDisplayItems) {
                if (savedPartnerDisplayItems[key] != null) {
                  partnerDisplayItems[key] = savedPartnerDisplayItems[key];
                }
              }
            }

            VueCookies.set('partnerDisplayItems', JSON.stringify(partnerDisplayItems));
          } else {
            partnerDisplayItems = savedPartnerDisplayItems;
          }

          state.partnerDisplayItems = partnerDisplayItems;          
          return VueCookies.get('partnerDisplayItems')
        },
        getCustomsBrokerDisplayItems(state) {
          if (Object.keys(state.customsBrokerDisplayItems).length == 0) {
            if (VueCookies.get('customsBrokerDisplayItems') == null) {
              return {};
            }
            state.customsBrokerDisplayItems = VueCookies.get('customsBrokerDisplayItems');
          }
          return state.customsBrokerDisplayItems;
        },
        defaultSetCustomsBrokerDisplayItems(state) {
          const defaultCustomsBrokerDisplayItems = {
            rv: true,
            comment_flg: true,
            input_date: true,
            shipper_name: true,
            booking: true,
            ship_name: true,
            voy: true,
            place_of_receipt: true,
            loading_area: true,
            landing_area: true,
            departure_date:true,
            cut_date: true,
            quantity: true,
            sts_ship: true,
            container_info: true,
            pick_up_flg: true,
            pick_up_date: true,
            pick_up_time: true,
            working_style: true,
            shipping_form: true,
            customs_clearance: true,
            cargo_location: true,
            ledger_number: true,
            custom_materials_flg: true,
            ms_i_flg: true,
            hs_i_flg: true,
            vehicle_information_flg: true,
            picture_flg: true,
            carry_in_slip_flg: true,
            acl_flg: true,
            export_permit_flg: true,
            draft_bl_flg: true,
            invoice_flg: true,
          };

          const savedCustomsBrokerDisplayItems = VueCookies.get('customsBrokerDisplayItems');
          let customsBrokerDisplayItems;
          
          if (!savedCustomsBrokerDisplayItems || Object.keys(savedCustomsBrokerDisplayItems).length !== Object.keys(defaultCustomsBrokerDisplayItems).length) {
            customsBrokerDisplayItems = { ...defaultCustomsBrokerDisplayItems };

            if (savedCustomsBrokerDisplayItems) {
              for (const key in defaultCustomsBrokerDisplayItems) {
                if (savedCustomsBrokerDisplayItems[key] != null) {
                  customsBrokerDisplayItems[key] = savedCustomsBrokerDisplayItems[key];
                }
              }
            }

            VueCookies.set('customsBrokerDisplayItems', JSON.stringify(customsBrokerDisplayItems));
          } else {
            customsBrokerDisplayItems = savedCustomsBrokerDisplayItems;
          }

          state.customsBrokerDisplayItems = customsBrokerDisplayItems;
          return VueCookies.get('customsBrokerDisplayItems');
        },
        async mailList(state) {
          if (!state.mailList) {
            state.mailList = [];
            const api = new ApiClient();
            const result = await api.get('fc/mail/list');
            const list = result.list;
            Object.keys(list).forEach(function(key) {
              state.mailList.push(list[key])
            });
          }
          return state.mailList;
        },
        async customerList(state) {
          if (!state.customerList) {
            state.customerList = [];
            const api = new ApiClient();
            const result = await api.get('fc/customer/customer_list');
            const list = result.list;
            list.forEach(function(row) {
              state.customerList.push({id: row.id, name:row.name});
            });
          }
          return state.customerList;
        },
        async customerName(state) {
            if (!state.customerName) {
                const api = new ApiClient();
                const result = await api.get('partner/login/customer_name');
                state.customerName = result.name;
            }
            return state.customerName;
        },
    },
    mutations: {
        initPostParam(state) {
          state.postParam = {};
        },
        setToken(state, token) {
            state.token = token;
            VueCookies.set('__jwt_token_admin', token);
        },
        setDetailParam(state, table) {
            state.postParam = table.detail;
            state.initDetail = true;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        setPostParam(state, table) {
            if (table.group != null) {
                if (!state.postParam[table.group]) {
                    state.postParam[table.group] = [];
                }

                if (table.index != null) {
                    if (!state.postParam[table.group][table.index]) {
                        state.postParam[table.group][table.index] = {};
                    }
                    state.postParam[table.group][table.index][table.label] = table.value;
                } else {
                    state.postParam[table.group][table.label] = table.value;
                }
            } else {
                if (table.index != null) {
                    if (!state.postParam[table.label]) {
                        state.postParam[table.label] = [];
                    }
                    state.postParam[table.label][table.index] = table.value;
                } else {
                    state.postParam[table.label] = table.value;
                }
            }
        },
        setDisplayItems(state, displayItems) {
          state.displayItems = displayItems;
          VueCookies.set('displayItems', JSON.stringify(state.displayItems), '50y');
        },
        setPartnerDisplayItems(state, displayItems) {
          state.displayItems = displayItems;
          VueCookies.set('partnerDisplayItems', JSON.stringify(state.displayItems), '50y');
        },
        setCustomsBrokerDisplayItems(state, displayItems) {
          state.displayItems = displayItems;
          VueCookies.set('customsBrokerDisplayItems', JSON.stringify(state.displayItems), '50y');
        },

    },
    actions: {
        initPostParam(state) {
          state.commit('initPostParam');
        },
        setToken(state, token) {
            state.commit('setToken', token);
        },
        setErrors(state, errors) {
            state.commit('setErrors', errors);
        },
        setPostParam(state, table) {
            state.commit('setPostParam', table);
        },
        setDetailParam(state, table) {
            state.commit('setDetailParam', table);
        },
        setDisplayItems(state, displayItems) {
          state.commit('setDisplayItems', displayItems);
        },
        setPartnerDisplayItems(state, partnerDisplayItems) {
          state.commit('setPartnerDisplayItems', partnerDisplayItems);
        },
        setCustomsBrokerDisplayItems(state, customsBrokerDisplayItems) {
          state.commit('setCustomsBrokerDisplayItems', customsBrokerDisplayItems);
        },
    },
    modules: {

    },
})
